import React from 'react'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const GraficoResultadoPorMes = ({ indicador }) => {
  const data = {
    labels: indicador.resultadoPorMes.labels,
    datasets: [
      {
        label: 'Saídas últimos 6 meses',
        data: indicador.resultadoPorMes.total,
        backgroundColor: indicador.resultadoPorMes.cores,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true, // importante
        ticks: {
          callback: (value) => `R$ ${value}`,
        },
      },
    },
  }

  return (
    <div style={{ width: '100%', height: '180px' }}>
      <Bar
        key={JSON.stringify(indicador.entradas6meses.total)}
        data={data}
        options={options}
        redraw
      />
    </div>
  )
}

export default GraficoResultadoPorMes
